var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkbox" }, [
    _c("input", {
      attrs: {
        id: _vm.id,
        type: "checkbox",
        name: _vm.id,
        disabled: _vm.disabled,
      },
      domProps: { checked: _vm.checked },
      on: {
        change: function ($event) {
          return _vm.$emit("change", $event.target.checked)
        },
      },
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.id } }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }